/*
 * @Author: your name
 * @Date: 2021-08-26 10:16:35
 * @LastEditTime: 2021-09-08 18:30:16
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \standard-business\client\src\store\modules\sec-send.js
 */
const state = {
  dataSource: [],
  goodsIds: [], // 商品ids
  goodsFlag: '', // 商品范围
  goodsTable: [],
  fromPage: '', // 1满减送；2秒杀
  activityId: '', // 活动id
  showBackBtn: true, // 是否显示返回管理商品按钮
  sortMap: {}, //满减送活动排序键值对 key:spuid value:sort
};

const mutations = {
  CHANGE_DATA_SOURCE: (state, dataSource) => {
    state.dataSource = dataSource;
  },
  SET_GOODS_TABLE: (state, goodsTable) => {
    state.goodsTable = goodsTable;
  },
  SET_GOODS_IDS: (state, ids) => {
    state.goodsIds = ids;
  },
  SET_GOODS_FLAG: (state, flag) => {
    state.goodsFlag = flag;
  },
  SET_FROM_PAGE: (state, fromPage) => {
    state.fromPage = fromPage;
  },
  SET_ACTIVITY_ID: (state, id) => {
    state.activityId = id;
  },
  SET_SHOW_BACK_BTN: (state, flag) => {
    state.showBackBtn = flag;
  },
  SET_SORT_MAP: (state, sortMap) => {
    state.sortMap = sortMap;
  },
};

const getters = {
  goodsIds: (state, getter) => state.goodsIds,
  goodsFlag: (state, getter) => state.goodsFlag,
  dataSource: (state, getter) => state.dataSource,
  goodsTable: (state, getter) => state.goodsTable,
  fromPage: (state, getter) => state.fromPage,
  activityId: (state, getter) => state.activityId,
  showBackBtn: (state, getter) => state.showBackBtn,
  sortMap: (state, getter) => state.sortMap,
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
};
